import React from 'react';
import ArenaStreaming from '../data/streaming/ArenaStreaming';
import GeniusStreaming from '../data/streaming/GeniusStreaming';
import GeniusStreamingV3 from '../data/streaming/GeniusStreamingV3';
import RadarStreaming from '../data/streaming/RadarStreaming';
import { getArenaStreamingProps, getBetgeniusStreamingProps, getBetgeniusV3StreamingProps, getBetradarStreamingProps, getIgameMediaStreamingProps, isMatchArenaStreaming, isMatchBetgeniusStreaming, isMatchBetgeniusV3Streaming, isMatchBetradarStreaming, isMatchIgameMediaStreaming } from '../data/streaming/streamingUtils';
import { StreamingContext } from './Live';
import IgameMediaStreaming from '../data/streaming/IgameMediaStreaming';


function Streaming(props) {
    const streamingContext = React.useContext(StreamingContext);
    const streamingId = streamingContext.streamingId;

    if (streamingId == null) {
        return null;
    }

    const streamingMatchId = streamingContext.streamingMatchId;
    const streamingGenius = isMatchBetgeniusStreaming(streamingContext.streamingProps) && getBetgeniusStreamingProps();
    const streamingGeniusV3 = isMatchBetgeniusV3Streaming(streamingContext.streamingProps) && getBetgeniusV3StreamingProps();
    const streamingRadar = isMatchBetradarStreaming(streamingContext.streamingProps) && getBetradarStreamingProps();
    const streamingArena = isMatchArenaStreaming(streamingContext.streamingProps) &&  getArenaStreamingProps();
    const streamingIgameMedia = isMatchIgameMediaStreaming(streamingContext.streamingProps) && getIgameMediaStreamingProps();
    
    return (
        <>
            {streamingRadar &&
                <RadarStreaming matchId={streamingMatchId} streamId={streamingId} />
            }
            {streamingArena &&
                <ArenaStreaming matchId={streamingMatchId} streamId={streamingId} />
            }
            {streamingIgameMedia &&
                <IgameMediaStreaming matchId={streamingMatchId} streamId={streamingId} />
            }
            {streamingGenius &&
                <GeniusStreaming fid={streamingId} gci={streamingGenius[0].gci} />
            }
            {streamingGeniusV3 &&
                <GeniusStreamingV3 fid={streamingId} confData={streamingGeniusV3[0]} />
            }
        </>
    );
}
            
export default Streaming;